import { useState } from "react";
import { SpeechBubbleView } from "../views/speechBubbleView.jsx";
import { useParams } from "react-router-dom";
import { updateProgressReduxCB } from "../util/helpersFunction.js";
import locationTask from "../data/locationTask.json";
import images from "../images/images.js";
import ChatApi from "../util/chatApi.js"; 

function SpeechBubble() {
  const [isChecked, setIsChecked] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [currentStep, setCurrentStep] = useState(3);
  const [userInputValue, setUserInputValue] = useState("");
  const quest = "speechBubble";
  const { id, mode } = useParams();
  const location = locationTask[id];
  const { question} = location.speechBubble || {};
  const title = location?.title;
  const questImageKey = `speechBubble_${id}`;
  const imageKey = `drawing_${id}`;
  const [chatFeedback, setChatFeedback] = useState("");
  const [loading, setLoading] = useState(false);

  if (!location) {
    return <div>Location not found</div>;
  }

  const handleAnswerACB = async (answer) => {
    setIsChecked(true);
    setCurrentStep(4); // advance progress bar
    setUserInputValue(answer);
    setLoading(true);

    // Use ChatGPT to generate feedback
    try {
      const response = await ChatApi.getChatResponse(
        answer,
        `Give playful and short feedback on the user's answer to the following question: ${question}.`
      );
      setChatFeedback(response);
    } catch (error) {
      console.error("ChatGPT feedback error:", error);
      setChatFeedback("Oops! Couldn't fetch feedback. Try again later!");
    } finally {
      setLoading(false);
    }
    const status = "success";
    updateProgressReduxCB(id, mode, status, quest);
  };

  function handleInputChangeACB(e) {
    setInputValue(e.target.value);
  }

  function handleGoToModeInfoACB() {
    window.location.hash = `#/questComplete/${id}/${mode}/${quest}`;
  }

  return (
    <SpeechBubbleView
      mode={mode}
      title={title}
      onComplete={handleGoToModeInfoACB}
      location={location}
      question={question}
      onAnswer={handleAnswerACB}
      comment={chatFeedback} 
      images={images}
      isChecked={isChecked}
      currentStep={currentStep}
      userInputValue={userInputValue}
      inputValue={inputValue}
      onInputChange={handleInputChangeACB}
      questImageKey={questImageKey}
      loading={loading}
      imageKey={imageKey}
    />
  );
}

export { SpeechBubble };
